import { TabConstants } from '../components/tabs/Tabs.constants'

export const isChartTabSelected = (currentURL: string) => {
  return (
    !!currentURL &&
    (currentURL === TabConstants.VITALS_TAB ||
      currentURL === TabConstants.CHART_ROUTE ||
      currentURL === TabConstants.TIMELINE_TAB ||
      currentURL === TabConstants.PATIENT_INFO_ROUTE ||
      currentURL === TabConstants.PATIENT_DEMOGRAPHICS ||
      currentURL === TabConstants.PATIENT_ALLERGIES ||
      currentURL === TabConstants.PATIENT_ALLERGIES_LIST ||
      currentURL === TabConstants.PATIENT_MEDICAL_HISTORY ||
      currentURL === TabConstants.MEDICAL_HISTORY_LOOKUP ||
      currentURL === TabConstants.PATIENT_MEDICATIONS ||
      currentURL === TabConstants.PATIENT_MEDICATIONS_SEARCH ||
      currentURL === TabConstants.TIMELINE_ACTIONS_SEARCH ||
      currentURL === TabConstants.ADD_MEDICATIONS_ADMINISTERED ||
      currentURL === TabConstants.ADD_MEDICATIONS_ADMINISTERED_SEARCH ||
      currentURL === TabConstants.CARDIAC_PROCEDURE ||
      currentURL === TabConstants.INTUBATION_PROCEDURE ||
      currentURL === TabConstants.TRIP_INFORMATION ||
      currentURL === TabConstants.EXPOSURE ||
      currentURL === TabConstants.PICKUP_ADDRESS ||
      currentURL === TabConstants.AIRWAY_PROCEDURE ||
      currentURL === TabConstants.IMAGING_ULTRASOUND_PROCEDURE ||
      currentURL === TabConstants.CHILDBIRTHOB_PROCEDURE ||
      currentURL === TabConstants.INITIATE_IV_PROCEDURE ||
      currentURL === TabConstants.IMMOBILIZATION_PROCEDURE ||
      currentURL === TabConstants.MEDICAL_CONSULT_PROCEDURE ||
      currentURL === TabConstants.EXTRICATION_PROCEDURE ||
      currentURL === TabConstants.OPERATIONS_PROCEDURE ||
      currentURL === TabConstants.RESCUE_PROCEDURE ||
      currentURL === TabConstants.VENTILATOR_PROCEDURE ||
      currentURL === TabConstants.HOSPITAL_NOTIFY_PROCEDURE ||
      currentURL === TabConstants.TITRATE_PROCEDURE ||
      currentURL === TabConstants.WOUND_CARE_PROCEDURE ||
      currentURL === TabConstants.LABS_PROCEDURE ||
      currentURL === TabConstants.PERTINENT_NEGATIVE_PROCEDURE ||
      currentURL === TabConstants.PATIENT_NARRATIVE ||
      currentURL === TabConstants.CAD_IMPORT ||
      currentURL === TabConstants.CC_HPI ||
      currentURL === TabConstants.BILLING ||
      currentURL === TabConstants.INSURANCE_INFORMATION ||
      currentURL === TabConstants.RELATIONSHIPS_AND_GUARANTORS ||
      currentURL === TabConstants.PCS_INFORMATION ||
      currentURL === TabConstants.RELATIONSHIPS_AND_GUARANTORS ||
      currentURL === TabConstants.AUTHORIZATION_INFORMATION ||
      currentURL === TabConstants.CMS_INFORMATION ||
      currentURL === TabConstants.PAYMENT_INFORMATION ||
      currentURL === TabConstants.PATIENT_SEARCH ||
      currentURL === TabConstants.PATIENT_SEARCH_RESULTS ||
      currentURL === TabConstants.FACTORS_AFFECTING_CARE ||
      currentURL === TabConstants.SCENE_DESCRIPTION ||
      currentURL === TabConstants.INITIAL_ASSESSMENT ||
      currentURL === TabConstants.INITIAL_ASSESSMENT_COMMENTS ||
      currentURL === TabConstants.GLASSGOW_COMMA_SCORE ||
      currentURL === TabConstants.PEDIATRIC_TRAUMA_SCORE ||
      currentURL === TabConstants.DRAIN_PROCEDURE ||
      currentURL === TabConstants.PN_MEDICATION_PROCEDURE ||
      currentURL === TabConstants.STROKE_SCORE ||
      currentURL === TabConstants.ADDITIONAL_ASSESSMENTS ||
      currentURL === TabConstants.ADDITIONAL_ASSESSMENT_SUMMARY ||
      currentURL === TabConstants.BODY_ASSESSMENT)
  )
}
